// /home/ananun/fluorescence.pro/admin/src/components/Page404.jsx
// Page404.jsx

import React from "react";

export default function Page404() {
  return (
    <div>
      <div>ERROR 404</div>
    </div>
  );
}
